import News1 from "../assets/news/news1.webp";
import News2 from "../assets/news/news2.webp";
import News3 from "../assets/news/news3.webp";
import News4 from "../assets/news/news4.webp";
import Finalist1 from "../assets/home/finalist1.webp";
import Finalist2 from "../assets/home/finalist2.webp";
import Finalist3 from "../assets/home/finalist3.webp";
import MemberLogo1 from "../assets/home/test1.png";
import MemberLogo2 from "../assets/home/test2.png";

const FairsData = {
  attended: [
    { id: 1, title: "", location: "", date: "", image: News4, description: "" },
    { id: 2, title: "", location: "", date: "", image: News3, description: "" },
    { id: 3, title: "", location: "", date: "", image: News2, description: "" },
  ],
  upcoming: [
    { id: 4, title: "", location: "", date: "", image: News1, description: "" },
  ],
  awards: [
    {
      groupKey: "finalist",
      labelKey: "Finalist",
      items: [
        { id: 101, title: "Attracta Beauty Awards 2026", image: Finalist1 },
        { id: 102, title: "Travel Retail Awards 2026", image: Finalist2 },
      ],
    },
    {
      groupKey: "recognition",
      labelKey: "OfficialRecognition",
      items: [
        { id: 103, title: "Cosmoprof NA Las Vegas 2026", image: Finalist3 },
      ],
    },
    {
      groupKey: "member",
      labelKey: "Memberof",
      items: [
        { id: 104, title: "The Fragrance Foundation UK", image: MemberLogo1 },
        { id: 105, title: "MHB Group", image: MemberLogo2 },
      ],
    },
  ],
};

export default FairsData;
